export default {
  'some of template was not found': 'costManagement.template.templateNotFound',
  'already exist': 'costManagement.template.templateAlreadyExists',
}
